<template>
  <Fragment>
    <v-row style="margin-top: 30px; padding: 10px">
      <v-slider
        v-model.lazy="thresholdScore"
        label="Threshold"
        prepend-icon="mdi-script-text"
        :min="80"

        :max="100"
        :step="1"
        thumb-label="always"
      />

      <v-slider
        v-model.lazy="limit"
        label="Limit"
        prepend-icon="mdi-filter-check-outline"
        :min="5"
        :max="100"
        :step="10"
        thumb-label="always"
      />
    </v-row>

    <v-data-table
      group-by="group"
      sort-by="score"
      sort-desc
      :headers="headers"
      :items-per-page="topPerformers?topPerformers.length:10"
      dense
      item-key="mateId"
      :items="topPerformers"
    >
      <template v-slot:item.sn="{ index }">
        <span>{{ index + 1 }}</span>
      </template>
      <template v-slot:item.score="{ item }">
        <span>{{ Number(item.score || 0).toFixed(2) }}%</span>
      </template>
    </v-data-table>
  </Fragment>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import { Q_GET_TOPPERFORMERS } from '@/gql/command'

  export default {
    name: 'TopPerformers',
    data: () => ({
      headers: [
        { name: 'sn', value: 'sn' },
        { text: 'Name', value: 'name' },
        { text: 'Score (%)', value: 'score' },

      ],
      thresholdScore: 99,
      limit: 20,
    }),
    computed: {
      ...mapState('records', ['view', 'currentDate', 'startDate', 'endDate']),
      ...mapGetters([
        'team',
      ]),
    },
    apollo: {
      topPerformers: {
        query: Q_GET_TOPPERFORMERS,
        variables () {
          return {
            startDate: this.startDate,
            endDate: this.endDate,
            currentTeam: this.team,
            thresholdScore: this.thresholdScore,
            limit: this.limit,
          }
        },
      },
    },
  }
</script>

<style scoped>

</style>
